import {Component} from "react";
import UserSessionService from "../../../services/UserSessionService";
import {withRouter} from "react-router-dom";

class Logout extends Component {

    componentWillMount() {

        UserSessionService.logout();

        this.props.userHasAuthenticated(false);
        this.props.history.replace("/login");
    }

    render() {
        return null;
    }
}

export default withRouter(Logout);